import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { TabelaComponent } from './tabela/tabela.component';
import { LoadingComponent } from './loading/loading.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";
import { NotificacaoComponent } from './notificacao/notificacao.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ModalFeedbackComponent } from './feedback/modal-feedback/modal-feedback.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { DashboardAdvogadoComponent } from './dashboards/dashboard-advogado/dashboard-advogado.component';
import { LoginLawservicesComponent } from './login/login-lawservices/login-lawservices.component';
import { LoginImedComponent } from './login/login-imed/login-imed.component';
import { CadastroImedComponent } from './cadastro-novo-cliente/cadastro-imed/cadastro-imed.component';
import { CadastroLawservicesComponent } from './cadastro-novo-cliente/cadastro-lawservices/cadastro-lawservices.component';
import {NgxMaskDirective} from "ngx-mask";
import { FormularioComponent } from './login/formulario/formulario.component';
import { CadastroFormularioComponent } from './cadastro-novo-cliente/cadastro-formulario/cadastro-formulario.component';
import { InfoSaasCadastroComponent } from './cadastro-novo-cliente/info-saas-cadastro/info-saas-cadastro.component';
import { AssinaturaComponent } from './assinatura/assinatura.component';
import {MatTooltip} from "@angular/material/tooltip";
import { CalendarioComponent } from './calendario/calendario.component';
import { CrmDashboardListComponent } from './crm-dashboard-list/crm-dashboard-list.component';
import {RouterModule} from "@angular/router";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
    declarations: [
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        TabelaComponent,
        LoadingComponent,
        BreadcrumbComponent,
        NotificacaoComponent,
        FeedbackComponent,
        ModalFeedbackComponent,
        TutorialComponent,
        DashboardAdvogadoComponent,
        LoginLawservicesComponent,
        LoginImedComponent,
        CadastroImedComponent,
        CadastroLawservicesComponent,
        FormularioComponent,
        CadastroFormularioComponent,
        InfoSaasCadastroComponent,
        AssinaturaComponent,
        CalendarioComponent,
        CrmDashboardListComponent
    ],
    exports: [
        LoadingComponent,
        HeaderComponent,
        SidebarComponent,
        BreadcrumbComponent,
        TabelaComponent,
        FeedbackComponent,
        ModalFeedbackComponent,
        NotificacaoComponent,
        TutorialComponent,
        DashboardAdvogadoComponent,
        LoginLawservicesComponent,
        LoginImedComponent,
        CadastroLawservicesComponent,
        CadastroImedComponent,
        AssinaturaComponent,
        FormularioComponent,
        CalendarioComponent,
        FooterComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    MatTooltip,
    RouterModule,
    NgSelectModule
  ]
})
export class ComponentesModule { }
